import React, { useMemo } from "react";

function Places({
  mapWidth,
  mapHeight,
  showPlaces = true,
  important_places_svg, 
  important_places_details_svg,
  onPlaceClick, 
  selectedPlace,
}) {
  // === 1. عرض التفاصيل للمكان المختار فقط ===
  const filteredDetails = useMemo(() => {
    if (!important_places_details_svg || !selectedPlace?.id) {
      return null;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(important_places_details_svg, "image/svg+xml");
    const parserError = doc.querySelector("parsererror");
    if (parserError) {
      return null;
    }

    const targetId = String(selectedPlace.id);
    const targetGroup = doc.querySelector(`g[id="${targetId}"]`);
    if (!targetGroup) {
      return null;
    }

    // إنشاء SVG جديد يحتوي فقط على الـ g المطلوب + الـ defs إن وجدت
    const newSvg = doc.createElementNS("http://www.w3.org/2000/svg", "svg");
    newSvg.setAttribute("width", "4096");
    newSvg.setAttribute("height", "4096");
    newSvg.setAttribute("viewBox", "0 0 4096 4096");
    newSvg.setAttribute("fill", "none");
    newSvg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

    const defs = doc.querySelector("defs");
    if (defs) {
      newSvg.appendChild(defs.cloneNode(true));
    }

    newSvg.appendChild(targetGroup.cloneNode(true));

    return newSvg.outerHTML;
  }, [important_places_details_svg, selectedPlace?.id]);

  // === 2. تحويل العلامات القابلة للكليك إلى React elements ===
  const parsedPlaces = useMemo(() => {
    if (!important_places_svg || !showPlaces) return [];

    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(important_places_svg, "image/svg+xml");
      const parserError = doc.querySelector("parsererror");
      if (parserError) {
        return [];
      }

      const elements = Array.from(doc.querySelectorAll("g[id] > *, [id]:not(g)"));

      return elements.map((el) => {
        const placeEl = el.hasAttribute("id") ? el : el.closest("[id]");
        if (!placeEl || !placeEl.hasAttribute("id")) {
          return null;
        }

        const id = placeEl.getAttribute("id");
        const tagName = el.tagName.toLowerCase();

        // تحويل kebab-case إلى camelCase لتوافق React
        const attributes = {};
        for (let attr of el.attributes) {
          if (attr.name === "id") continue;
          const reactName = attr.name.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
          attributes[reactName] = attr.value;
        }

        return React.createElement(tagName, {
          key: `${id}-${tagName}-${Math.random().toString(36).substr(2, 9)}`,
          ...attributes,
          pointerEvents: "all",
          style: {
            cursor: "pointer",
            transition: "all 0.3s ease",
          },
          onMouseEnter: () => onPlaceClick?.({ id, action: "hover" }),
          onMouseLeave: () => onPlaceClick?.({ id: null, action: "hover" }),
          onMouseDown: (e) => {
            e.stopPropagation();
            e.preventDefault();
          },
          onMouseUp: (e) => {
            e.stopPropagation();
            e.preventDefault();
            onPlaceClick?.({ id, action: "click" });
          },
        });
      }).filter(Boolean);
    } catch (err) {
      return [];
    }
  }, [important_places_svg, showPlaces, onPlaceClick]);

  if (parsedPlaces.length === 0 && !filteredDetails) return null;

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
      }}
    >
      {/* طبقة العلامات القابلة للكليك */}
      <svg
        width={mapWidth}
        height={mapHeight}
        viewBox="0 0 4096 4096"
        style={{ position: "absolute", inset: 0 }}
      >
        <g pointerEvents="all">{parsedPlaces}</g>
      </svg>

      {/* طبقة التفاصيل عند اختيار مكان */}
      {filteredDetails && (
        <>
          <div
            style={{
              position: "absolute",
              top: 20,
              left: 20,
              color: "white",
              padding: "15px",
              fontSize: "24px",
              fontWeight: "bold",
              borderRadius: "8px",
              zIndex: 100,
              pointerEvents: "none",
            }}
          >
            DETAILS LOADED: {selectedPlace.id}
          </div>

          <svg
            width={mapWidth}
            height={mapHeight}
            viewBox="0 0 4096 4096"
            preserveAspectRatio="xMidYMid meet"
            style={{
              position: "absolute",
              inset: 0,
              pointerEvents: "none",
              zIndex: 30,
            }}
            dangerouslySetInnerHTML={{ __html: filteredDetails }}
          />
        </>
      )}
    </div>
  );
}

export default Places;
